import React from "react";
import { EllipsisVertical } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { cn } from "@/lib/utils";

interface TutorialTagsProps {
  tags: string[];
}

export const Tags = ({ tags }: TutorialTagsProps) => {
  const visibleTags = tags.slice(0, 5);
  const remainingTags = tags.slice(5);
  const hasMoreTags = tags.length > 5;

  return (
    <div className="flex flex-wrap gap-1.5">
      {visibleTags.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1.5 px-2 py-1 text-xs rounded-full bg-secondary text-secondary-foreground dark:bg-[#2A2A2A] dark:text-white whitespace-nowrap overflow-hidden max-w-full"
        >
          {/* If tag has an icon, it would be added here */}
          <span className="truncate">{tag}</span>
        </span>
      ))}

      {hasMoreTags && (
        <Popover>
          <PopoverTrigger asChild>
            <span className="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full bg-secondary text-secondary-foreground dark:bg-[#2A2A2A] dark:text-white cursor-pointer">
              <EllipsisVertical className="h-3 w-3" />
            </span>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-2">
            <div className="flex flex-col gap-1.5">
              {remainingTags.map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-1.5 px-2 py-1 text-xs rounded-full bg-secondary text-secondary-foreground dark:bg-[#2A2A2A] dark:text-white whitespace-nowrap overflow-hidden max-w-full"
                >
                  {/* If tag has an icon, it would be added here */}
                  <span className="truncate">{tag}</span>
                </span>
              ))}
            </div>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};
